import { render } from "./EditCallHistoryModal.vue?vue&type=template&id=502639d6&scoped=true"
import script from "./EditCallHistoryModal.vue?vue&type=script&lang=js"
export * from "./EditCallHistoryModal.vue?vue&type=script&lang=js"

import "./EditCallHistoryModal.vue?vue&type=style&index=0&id=502639d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502639d6"]])

export default __exports__